<template>
	<sky-charts
		:api-conf="apiConf"
		ref="chart"
		:before-render="beforeRender"
		:queryCondition="condition"
		:config="chartConfig"
		:extend="extend"
	>
	</sky-charts>
</template>

<script>
import apiConf from '@/backend/apiConfig/apiConfig';
import mixins from './ga_mixins';
import weburlSelect from '@/components/website/weburlSelect.js';

const xData = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
const yData = [
	'00:00',
	'01:00',
	'02:00',
	'03:00',
	'04:00',
	'05:00',
	'06:00',
	'07:00',
	'08:00',
	'09:00',
	'10:00',
	'11:00',
	'12:00',
	'13:00',
	'14:00',
	'15:00',
	'16:00',
	'17:00',
	'18:00',
	'19:00',
	'20:00',
	'21:00',
	'22:00',
	'23:00',
];

export default {
	name: 'ga_timeline',
	// mixins: [mixins],
	props: {
		condition: {
			required: false,
		},
	},
	data() {
		let that = this;
		return {
			apiConf: null,
			copy: [],
			chartConfig: {
				name: '时段分析',
				type: 'veHeatmap',
				columns: ['day', 'time', 'num'],
				chartSettings: {
					labelMap: {
						time: '时间',
						num: '用户数量',
					},
				},
				afterConfig: options => {
					options.tooltip = {
						...options.tooltip,
						formatter: function formatter(items) {
							var tpl = [];
							var title = items.name;
							var marker = items.marker;
							var itemData = items.value[2];
							tpl.push(title + '<br>');
							tpl.push(that.copy[items.dataIndex].submitDate + '<br>');
							tpl.push(marker);
							tpl.push('num: ' + itemData);
							tpl.push('<br>');
							return tpl.join('');
						},
					};
					return options;
				},
			},
			extend: {
				series: {
					type: 'heatmap',
				},
				yAxis: {
					type: 'category',
					data: yData,
					splitArea: {
						show: true,
					},
				},
			},
			beforeRender(data) {
				let dataCopy = [];
				for (let i = 0; i < xData.length; i++) {
					for (let j = 0; j < yData.length; j++) {
						let im = data.find(item => {
							let { day, time } = item;
							return day === xData[i] && time === yData[j];
						});
						if (im) {
							dataCopy.push(im);
						} else {
							dataCopy.push({
								day: xData[i],
								time: yData[j],
								num: null,
							});
						}
					}
				}
				that.copy = dataCopy;
				return dataCopy;
			},
			data: {},
		};
	},
	watch: {
		condition: {
			handler(val) {
				this.apiConf = {
					api: apiConf.website['get' + weburlSelect(val.status) + 'TimeReport'],
					config: {
						timeout: 60000,
					},
				};
			},
			immediate: true,
			deep: true,
		},
	},
};
</script>

<style scoped></style>
